<div class="row bloccodati">
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
       [labelInput]="'Tipo richiedente'" [valueInput]="ctxBodyFascicolo.fascicolo.tipoRichiedente ? 'Interno' : 'Esterno'"></div>
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
       [labelInput]="'Oggetto'" [valueInput]="ctxBodyFascicolo.fascicolo.oggetto"></div>
</div>
<div class="row bloccodati">
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
     [labelInput]="'Accolta'" [valueInput]="ctxBodyFascicolo.fascicolo.accolta ? 'Si' : 'No'"></div>
</div>

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
